import { render } from "./CompanyList.vue?vue&type=template&id=84b503e4&scoped=true"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"

import "./CompanyList.vue?vue&type=style&index=0&id=84b503e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b503e4"]])

export default __exports__